import React, { useState, useEffect } from 'react';
import { getTheme, toggleTheme } from '../../utils/themeManager';

const ThemeToggle = () => {
  const [currentTheme, setCurrentTheme] = useState(getTheme());
  
  // Écouter les changements de thème
  useEffect(() => {
    const handleThemeChange = (e) => {
      setCurrentTheme(e.detail || getTheme());
    };
    
    window.addEventListener('themeChanged', handleThemeChange);
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);
  
  return (
    <button 
      onClick={toggleTheme}
      className="p-2 rounded-md hover:bg-base-200 transition-colors duration-200"
      aria-label={currentTheme === 'light' ? 'Passer au mode sombre' : 'Passer au mode clair'}
    >
      {currentTheme === 'light' ? (
        // Icône lune pour passer au mode sombre
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-neutral" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      ) : (
        // Icône soleil pour passer au mode clair
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;